<template>
  <div class="home">
    <v-app-bar
      app
      dark
      fixed
      style="background-color: var(--color-primary) !important"
    >
      <template v-slot:img="{ props }">
        <v-img v-bind="props" color="primary"></v-img>
      </template>

      <v-app-bar-nav-icon @click="toggleDrawer()"></v-app-bar-nav-icon>

      <v-toolbar-title class="font-sahel">{{ toolbarTitle }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="logout">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on"> mdi-logout </v-icon>
          </template>
          <span>{{ $t("nav-logout") }}</span>
        </v-tooltip>

        <v-tooltip> </v-tooltip>
      </v-btn>

      <!-- <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn> -->
    </v-app-bar>

    <SideNavigation ref="navigation" @logout="logout" />

    <div class="pa-2">
      <router-view name="mainPlaceholder" class="homePlaceholder"></router-view>
    </div>
  </div>
</template>

<script>
import SideNavigation from "../components/navigation/SideNavigation.vue";
import ResultType from "../model/ResultType";

export default {
  name: "Home",
  components: {
    SideNavigation,
  },
  data() {
    return {
      toolbarTitle: "",
    };
  },
  computed: {},
  mounted() {
    ////debugger
    this.pageLoad();
    ////debugger
  },
  methods: {
    async pageLoad() {

      

      //this.GetAllStateForAdmin();
      this.$store.dispatch("GetForcedInboxCount").then((result) => {
        //console.log(result);
        this.setSideNavigationArray();
        ////debugger
        if (result.type === ResultType.success) {
          if (result.data > 0) {
            this.$store.commit("setDisableSideMenu", true);

            this.$router.push({ name: "inbox" });
          } else {
            this.$store.commit("setDisableSideMenu", false);
            if (this.$router.currentRoute.name == "home") {
              this.$router.push({ name: "profile" });
            }
          }
        }
      });
////debugger;
      // this.$vuetify.theme.themes.name="قالب سبز";

    },
    logout() {
      this.$store.dispatch("logout");
    },
    toggleDrawer() {
      ////console.log(this.$refs);
      this.$refs.navigation.toggleDrawer();
    },
    GetAllStateForAdmin() {
      ////debugger
      this.$store.dispatch("GetAllStateForAdmin").then((result) => {
        console.log(result);
        ////debugger
        if (result.type === ResultType.success) {
          ////console.log(result.data);
          this.setSideNavigationArray();
          /*if (
            this.$store.state.settings.VacationBudgeCount != result.data.VactionNum ||
            this.$store.state.settings.MissionBudgeCount != result.data.MissionNum ||
            this.$store.state.settings.IOBudgeCount != result.data.IoNum ||
            this.$store.state.settings.ExtraWorkBudgeCount != result.data.EwNum
          ) {
            this.setSideNavigationArray();
          }*/
        }
      });
    },
    setSideNavigationArray() {
      let arr = this.$store.state.permission.permissionList;
      ////console.log('setSideNavigationArray');
      //debugger
      this.$refs.navigation.setNavigationArray(arr);
      ////debugger
    },
  },
  watch: {
    /*"$store.state.permission.permissionList": function () {
      this.setSideNavigationArray();
    },*/
    $route: {
      immediate: true,
      handler(to) {
        //document.title = to.meta.title || "Some Default Title";
        this.toolbarTitle =
          this.$t(to.meta.toolbarTitle) || this.$t("app-name") || "WebKart";

        this.GetAllStateForAdmin();
      },
    },
  },
};
</script>

<style>
.home {
  background-color: var(--background) !important;
}

.left {
  margin-right: auto;
  float: left;
}

.current-date {
  background-color: rgba(66, 166, 248, 0.308);
  padding: 5px 10px;
  border-radius: 50px;
  font-size: 0.875rem;
}

.homePlaceholder {
  padding-bottom: 30px;
}
</style>